import type { CSSProperties } from 'react';

/** Shimmering placeholder block — building unit for skeleton loaders. */
export function Skeleton({ w = '100%', h = 16, radius = 8, style }: { w?: number | string; h?: number | string; radius?: number; style?: CSSProperties }) {
  return <span className="wp-skel" style={{ display: 'block', width: w, height: h, borderRadius: radius, ...style }} />;
}

/** Grid of card skeletons (catalog, course grids). */
export function CardGridSkeleton({ count = 6, cols = 3 }: { count?: number; cols?: number }) {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: `repeat(${cols}, 1fr)`, gap: 18 }}>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="card" style={{ overflow: 'hidden' }}>
          <Skeleton h={96} radius={0} />
          <div style={{ padding: 16, display: 'flex', flexDirection: 'column', gap: 10 }}>
            <Skeleton w="70%" h={15} />
            <Skeleton w="45%" h={12} />
            <Skeleton w="100%" h={7} radius={99} />
          </div>
        </div>
      ))}
    </div>
  );
}

/** Stacked row skeletons (lists, rosters, tables). */
export function ListSkeleton({ rows = 6 }: { rows?: number }) {
  return (
    <div className="card" style={{ overflow: 'hidden' }}>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '14px 18px', borderTop: i ? '1px solid var(--line)' : 'none' }}>
          <Skeleton w={36} h={36} radius={99} />
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 7 }}>
            <Skeleton w="40%" h={13} />
            <Skeleton w="25%" h={11} />
          </div>
          <Skeleton w={64} h={22} radius={99} />
        </div>
      ))}
    </div>
  );
}
